/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, March 2022
 * @flow
 */

import React from 'react';
import { getPopupConfig } from '../../components/Popup';
import FireboardUtils from '../../util/fireboard-util';
import API from '../../requests';
import View from './views/Desktop';
import { connect } from 'react-redux';

class OutOfStock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popup: undefined,
      outOfStockItems: [],
      outOfStockSearchList: [],
      menuType: '',
      includeUnavailable: false,
    };
    this.itemToBeUpdated = {};
  }

  componentDidMount() {
    const { match } = this.props;
    const { menuType } = match?.params || {};
    this.state.menuType = menuType;
    this.getOutOfStockList(menuType);
  }

  getPopup = (type, heading, message, callback) => {
    const popup =
      type === "spinner"
        ? getPopupConfig("spinner")
        : getPopupConfig("error", () => {
          callback && callback();
          this.setState({ popup: undefined });
        });
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    this.setState({ popup });
  };

  handleErrorPopup = (error) => {
    const errorMsg = error.response
      ? error.response.data
      : error.message;
    FireboardUtils.addNetworkLogs(error.response);
    this.getPopup("error", null, errorMsg);
  };

  getOutOfStockList = (type, hideSpinner) => {
    if (!hideSpinner) {
      this.getPopup('spinner', 'Getting out of stock list');
    }
    let req = 'getOutOfStockItemList';
    if (type === 'modifiers') req = 'getOutOfStockModifierList';
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const { id } = storeInfo.data;

    API[req]({
      storeId: id,
    }).then(res => {
      this.setState(
        {
          outOfStockItems: res.data,
          popup: undefined,
        },
      );
      FireboardUtils.addNetworkLogs(res);
    }).catch(error => this.handleErrorPopup(error));
  };

  onSearchOutOfStock = (value) => {
    this.getPopup('spinner', 'Searching items');
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const { id } = storeInfo.data;
    const { includeUnavailable, menuType } = this.state;
    let req = 'searchItemStock';
    if (menuType === 'modifiers') req = 'searchModifierStock';
    API[req]({
      storeId: id,
      postId: null,
      name: value,
      includeUnavailable,
    }).then(res => {
      this.setState({
        outOfStockSearchList: res.data,
        popup: undefined,
      });
      FireboardUtils.addNetworkLogs(res);
    }).catch(error => this.handleErrorPopup(error));
  };

  onUpdateItemStock = (item) => {
    this.itemToBeUpdated = item;
    this.setState({ popup: { type: 'updateStockStatus' } });
  };

  updateSearchedItem = (updatedItem) => {
    const { outOfStockSearchList } = this.state;
    const copiedOutOfStockSearchList = [...outOfStockSearchList];
    const index = copiedOutOfStockSearchList.findIndex(item => item.id === updatedItem.id);
    if (index > -1) {
      copiedOutOfStockSearchList[index] = updatedItem;
    }
    this.setState({
      outOfStockSearchList: copiedOutOfStockSearchList,
      popup: undefined,
    });
  };

  onReloadOutOfStock = () => {
    const { menuType } = this.state;
    this.getOutOfStockList(menuType);
  };

  onToggleIncludeUnavailable = () => {
    this.setState(prevState => ({
      includeUnavailable: !prevState.includeUnavailable,
    }));
  };

  goBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  closePopup = () => {
    this.setState({ popup: undefined });
  };

  invokeItemStatusUpdateApi = (backInStockDate) => {
    const item = { ...this.itemToBeUpdated };
    this.getPopup('spinner', 'Updating item stock');
    const { menuType } = this.state;
    let request = 'updateItemStock';
    if (menuType === 'modifiers') request = 'updateModifierStock';
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const { id } = storeInfo.data;
    const payload = {
      storeId: id,
      id: item.id,
      stocked: !item.stocked,
    };
    if (backInStockDate) {
      payload['backInStockDate'] = new Date(backInStockDate).toISOString();
    }
    API[request](payload)
      .then(res => {
        this.getOutOfStockList(menuType, true);
        this.updateSearchedItem({ ...res.data });
        FireboardUtils.addNetworkLogs(res);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  get viewProps() {
    const {
      popup,
      menuType,
      outOfStockItems,
      outOfStockSearchList,
      includeUnavailable,
    } = this.state;

    return {
      popup,
      menuType,
      outOfStockItems,
      outOfStockSearchList,
      includeUnavailable,
      itemToBeUpdated: this.itemToBeUpdated,
      goBack: this.goBack,
      onReloadOutOfStock: this.onReloadOutOfStock,
      onSearchOutOfStock: this.onSearchOutOfStock,
      onToggleIncludeUnavailable: this.onToggleIncludeUnavailable,
      onUpdateItemStock: this.onUpdateItemStock,
      closePopup: this.closePopup,
      invokeItemStatusUpdateApi: this.invokeItemStatusUpdateApi,
    };
  };

  render() {
    return (
      <View {...this.viewProps} />
    );
  }
};

const mapStateToProps = reduxProps => ({
  reduxProps
});

export default connect(mapStateToProps, null)(OutOfStock);
